import axios from 'axios';

export default axios.create ({
    //baseURL:'http://localhost:3010'
    baseURL:'https://1df4cfa679ca.ngrok.io'
    //baseURL:'https://my-json-server.typicode.com/irfanonk/webRTCdb'
})